import { Col, Row } from "react-bootstrap";
import { useTranslation } from "../../i18n";

function TimelineItem({ item }) {
  return (
    <div className="resume-item professional-item">
      <h4>{item.title}</h4>
      <h5>{item.organization}</h5>
      <p className="timeline-meta">
        {item.period} | {item.location}
      </p>
      <p>{item.description}</p>
      {Array.isArray(item.skills) && (
        <div className="timeline-stack">
          {item.skills.map((skill) => (
            <span key={skill}>{skill}</span>
          ))}
        </div>
      )}
    </div>
  );
}

function ProfessionalTimeline() {
  const { t } = useTranslation();
  const experienceItems = t("professional.experience.items");
  const educationItems = t("professional.education.items");

  return (
    <Row className="resume professional-timeline">
      <Col md={6} className="resume-left">
        <h3 className="resume-title">{t("professional.experience.heading")}</h3>
        {Array.isArray(experienceItems) &&
          experienceItems.map((item) => (
            <TimelineItem item={item} key={`${item.organization}-${item.title}`} />
          ))}
      </Col>

      <Col md={6} className="resume-right">
        <h3 className="resume-title">{t("professional.education.heading")}</h3>
        {Array.isArray(educationItems) &&
          educationItems.map((item) => (
            <TimelineItem item={item} key={`${item.organization}-${item.title}`} />
          ))}
      </Col>
    </Row>
  );
}

export default ProfessionalTimeline;
